if (
  !process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID ||
  !process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN ||
  !process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN
) {
  throw new Error('All CONTENTFUL_* .env must be set');
}

const contentfulGraphqlUrl = ({
  spaceId,
  accessToken,
  environment,
}: {
  spaceId: string;
  accessToken: string;
  environment?: string;
}): string => {
  return [
    `https://graphql.contentful.com/content/v1/spaces/${spaceId}`,
    environment && `/environments/${environment}`,
    `?access_token=${accessToken}`,
  ]
    .filter(Boolean)
    .join('');
};

export const CONTENTFUL_GRAPHQL_URL = contentfulGraphqlUrl({
  spaceId: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT,
});

export const CONTENTFUL_GRAPHQL_PREVIEW_URL = contentfulGraphqlUrl({
  spaceId: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN,
  environment: process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT,
});

export const ZAPIER_GRAPHQL_URL = `${process.env.NEXT_PUBLIC_ZAPIER_ORIGIN}/api/graphql/v2`;
